import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginPass } from 'api/Login';
import { getCookie, setCookie, removeCookie } from 'utils/Cookie';

const intialValue = {id:'', authTypes:[]}

const loadloginCookie = () => {
    const loginInfo = getCookie("login");
    return loginInfo;
}
export const loginSlice = createSlice({
    name: "login",
    initialState: loadloginCookie() || intialValue,
    // initialState : intialValue,
    reducers: {
        login : (state, {payload})=>{
            return {payload};
        },
        logout : (state) => {
            removeCookie("login");
            return intialValue;
        }
    },
    extraReducers : (builder) => {
        builder
            .addCase(asyncLoginPass.fulfilled,(state, {payload}) => {
                if (!payload.error) {
                    setCookie("login", JSON.stringify(payload),1);
                }
                return payload;
            })
            
    }
});

// 사용자 상세 페이지 로드
export const asyncLoginPass = createAsyncThunk('loginpass', async (json) => {
    return loginPass(json); 
});



export default loginSlice.reducer;
export const { login, logout } = loginSlice.actions;